const destinations = [
  { name: "Sweden & Scandinavia", context: "Ericsson headquarters in Stockholm, Nordic tech partnerships, business conferences", urgency: "Executive meetings and project reviews often booked 7–14 days in advance", icon: "ri-map-pin-2-line" },
  { name: "South Korea & Japan", context: "Samsung, Fujitsu, and tech partner offices; Pacific tech conferences; family connections", urgency: "Business travel often materializes with 2 weeks notice when project deadlines shift", icon: "ri-map-pin-2-line" },
  { name: "Germany", context: "Frankfurt tech hub, Siemens, SAP partner meetings, engineering conferences", urgency: "European business travel peaks September–November and January–March", icon: "ri-map-pin-2-line" },
  { name: "India & South Asia", context: "Family connections, business outsourcing partnerships, Diwali and wedding travel", urgency: "Heritage and family travel often happens on short notice due to family events", icon: "ri-map-pin-2-line" },
  { name: "China", context: "Supply chain visits, UTD research collaborations, Chinese New Year family travel", urgency: "Lunar New Year travel books out months ahead but passport issues surface last minute", icon: "ri-map-pin-2-line" },
  { name: "Caribbean & Mexico", context: "Family beach vacations, spring break trips, Cancun and Riviera Maya getaways via DFW", urgency: "Families book 4–8 weeks out and discover expired child passports at the last moment", icon: "ri-map-pin-2-line" },
];

const stats = [
  { stat: "55%", label: "of Richardson expedited requests are tech-sector business travel or heritage community travel" },
  { stat: "1–3 Weeks", label: "average notice tech professionals have before an international business trip" },
  { stat: "Mar–Jun", label: "peak season for UTD study-abroad departures and tech conference season" },
  { stat: "20 Miles", label: "to DFW — making Richardson one of Dallas metro's most DFW-connected suburbs" },
];

export default function RichardsonDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Richardson Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Telecom Corridor and North Dallas County clients. Understanding local travel behavior is part of why our document review catches issues before they derail your business trip or family vacation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Texas Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">We serve travelers across the Dallas metro and Texas with the same expedited passport expertise.</p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[{ name: "Dallas", href: "/cities/dallas" }, { name: "Plano", href: "/cities/plano" }, { name: "Frisco", href: "/cities/frisco" }].map((l) => (
                <a key={l.href} href={l.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {l.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}